import { render, staticRenderFns } from "./SearchWatch.vue?vue&type=template&id=209596aa&"
import script from "./SearchWatch.vue?vue&type=script&lang=js&"
export * from "./SearchWatch.vue?vue&type=script&lang=js&"
import style0 from "./SearchWatch.vue?vue&type=style&index=0&id=209596aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports